export default __webpack_public_path__ + "static/media/Oval_product.7e86951a.png";